import { StyledWrapper } from './style';
import Button from '../../../../components/Button';
import toast from 'react-hot-toast';

interface ConfirmSaveToastProps {
  onSave: () => void;
  onDiscard: () => void;
}

export function ConfirmSaveToast({ onSave, onDiscard }: ConfirmSaveToastProps) {
  const reportType = new URLSearchParams(window.location.search).get('type') || 'AIF002';
  return (
    <StyledWrapper id="confirm-save-toast">
      <p className="title" id="confirm-save-toast-title">
        Unsaved {reportType === 'AIF002' ? 'AIF' : 'AIFM'} Changes
      </p>
      <p className="text" id="confirm-save-toast-text">
        You have made updates to this {reportType === 'AIF002' ? 'AIF' : 'AIFM'} data.
        <br /> Would you like to keep these changes before moving on?
      </p>
      <div className="footer" id="confirm-save-toast-footer">
        <button id="confirm-save-toast-back-button" onClick={() => toast.remove()} className="back">
          Back
        </button>
        <div className="buttons" id="confirm-save-toast-buttons">
          <Button
            id="confirm-save-toast-discard-button"
            size="sm"
            onClick={onDiscard}
            variant="outlined"
          >
            Discard
          </Button>
          <Button id="confirm-save-toast-save-button" onClick={onSave} size="sm">
            Save Changes
          </Button>
        </div>
      </div>
    </StyledWrapper>
  );
}
